import React from 'react';
import { Box, Typography, Paper, IconButton, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { CustomButton } from '../../../shared';
import { CloseIcon, FilterLinesIcon } from '../../../../assets';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../redux/reducers/totalEngagementReducer';

const SearchUsingFilter = () => {
    const dispatch = useDispatch();
    const isFilter = false;
    
    const handleRemoveFilters = () => {
        console.log('handle remove filters called');
    };

    const handleSearch = (value) => {
        dispatch(actions.handleSearch({ searchTerm: value }));
    };

    return (
        <Box className="flex-row-space-between-center">
            {isFilter && <Box className="flex-row-gap-8x-justify-content-center-align-items-center">
                <Box className="npi-table-filter-box">
                    <Typography className='text-fw-500-fs-14px-lh-20px'>
                        West, South, +1
                    </Typography>
                    <Box className="icon" onClick={handleRemoveFilters}>
                        <CloseIcon color="#733567" height='10' width='10'/>
                    </Box>
                </Box>
                <Box>
                    <CustomButton
                        buttonColor="#FFFFFF"
                        customStyle={{ borderRadius: '8px' }}
                        icon={<FilterLinesIcon />}
                        title="More Filters"
                        titleColor="#344054"
                        
                    />
                </Box>
            </Box>}

            {/* Search Box */}
            <Box>
                <Paper
                    className='no-box-shadow'
                    component="form"
                    sx={{
                        p: '2px 4px', display: 'flex', alignItems: 'center', width: {
                            md: 200, lg: 250, xl: 320 
                        }, border: '1px solid #D0D5DD', borderRadius: '8px' 
                    }}
                >
                    <IconButton aria-label="search" sx={{ p: '10px' }} type="button">
                        <SearchIcon />
                    </IconButton>
                    <InputBase
                        inputProps={{ 'aria-label': 'search google maps' }}
                        placeholder="Search"
                        sx={{ ml: 1, flex: 1 }}
                        onChange={(e)=>handleSearch(e.target.value)}
                    />
                </Paper>
            </Box>

        </Box>
    );
};

export default SearchUsingFilter;